import React, { useEffect, useState } from 'react';
import { estoqueApi } from '../../../api/estoque';
import { COLORS } from '../../../theme';

export default function EstoquesTab({ produtoId }) {
  const [saldos, setSaldos] = useState([]);

  useEffect(() => {
    if (!produtoId) return;
    estoqueApi.saldos({ produto_id: produtoId }).then(setSaldos).catch(() => {});
  }, [produtoId]);

  if (!produtoId) return <p style={{ color: '#697180', fontSize: 14 }}>Salve o produto para ver os saldos de estoque.</p>;
  if (saldos.length === 0) return <p style={{ color: '#697180', fontSize: 14 }}>Nenhuma movimentação registrada para este produto ainda.</p>;

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
      <thead>
        <tr style={{ textAlign: 'left', borderBottom: `1px solid ${COLORS.border}` }}>
          <th style={{ padding: 8 }}>Depósito</th>
          <th style={{ padding: 8 }}>Lote</th>
          <th style={{ padding: 8 }}>Quantidade</th>
          <th style={{ padding: 8 }}>Atualizado em</th>
        </tr>
      </thead>
      <tbody>
        {saldos.map(s => (
          <tr key={s.id} style={{ borderBottom: `1px solid ${COLORS.border}` }}>
            <td style={{ padding: 8 }}>{s.deposito_nome}</td>
            <td style={{ padding: 8 }}>{s.lote_id ? s.lote_id : '-'}</td>
            <td style={{ padding: 8 }}>{s.quantidade}</td>
            <td style={{ padding: 8 }}>{s.atualizado_em}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
